import logger from "../../server/logger";

export const isEmpty = (value) => {
    try {
        // Verifica se é um array vazio
        if (Array.isArray(value) && value.length === 0) {
            return true;
        }

        // Verifica se é um objeto vazio
        if (typeof value === 'object' && value !== null && Object.keys(value).length === 0) {
            return true;
        }

        return false;
    } catch (error) {
        // logger.error('Error checking if isEmpty');
        console.error('(Homepage page) Error checking if isEmpty:', error);
        //reportError(error); // Send error report to backend
    }
};